import React, { useContext } from "react";
import styled from "styled-components";

import { AuthenticationContext } from "./Authentication.context";

const HeaderStyle = styled.header`
  min-height: 50px;
  width: 100%;
  background-color: yellow;
  position: fixed;
  top: 0;
  z-index: 1;
`;

const Header = ({ children }) => {
  const {
    user: { email },
    actions: { logout }
  } = useContext(AuthenticationContext);

  return (
    <HeaderStyle>
      {children} {email || ""} <button onClick={logout}>logout</button>
    </HeaderStyle>
  );
};

export default Header;
